
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component
  export default class BaseMaterialTestimony extends Vue {
    @Prop({ type: String, default: '' }) private readonly author!: string

    @Prop({ type: String, default: '' }) private readonly blurb!: string

    @Prop({ type: String, default: '' }) private readonly handle!: string

    @Prop({
      type: String,
      default: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/faces/card-profile1-square.jpg',
    }) private readonly avatar!: string
  }
